import LessonIcon from './LessonIcon';

export default LessonIcon;
